/*! Keeps the embedded Gorgias form from stealing first-load scroll position. */

(() => {
  const frames = document.querySelectorAll('[data-gorgias-contact-frame]');

  if (!frames.length || window.location.hash) {
    return;
  }

  frames.forEach((frame) => {
    const restoreScrollY = 0;
    let restored = false;

    const restoreIfFrameFocused = () => {
      if (restored || window.location.hash || document.activeElement !== frame) {
        return;
      }

      if (window.scrollY < restoreScrollY + 120) {
        return;
      }

      restored = true;
      frame.blur();
      window.scrollTo({
        top: restoreScrollY,
        left: window.scrollX,
        behavior: 'auto',
      });
    };

    const scheduleRestore = () => {
      [0, 50, 150, 400, 900].forEach((delay) => {
        window.setTimeout(restoreIfFrameFocused, delay);
      });
    };

    frame.addEventListener('load', scheduleRestore, { once: true });
    window.addEventListener('pageshow', scheduleRestore, { once: true });
    scheduleRestore();
  });
})();
